import MojitoCore from 'mojito/core';
import Image from 'presentation/components/image/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';

const classUtils = MojitoCore.Base.classUtils;

const SportIcon = props => {
    const { sportId, alt, mojitoTools } = props;
    const { config } = mojitoTools;

    return (
        <FlexPane
            config={config.container}
            class={classUtils.classNames('ta-SportIcon', props.class)}
        >
            <Image
                config={config.icon}
                src={config.sportIcons[sportId] || config.sportIcons.defaultIcon}
                alt={alt || `${sportId} icon`}
            />
        </FlexPane>
    );
};

export default SportIcon;
